import Header from "../Header";
import {Outlet} from 'react-router-dom'
import styled from "styled-components";
import {Box} from '@mui/material'
import LinearDeterminate from "../LinearDeterminate";

export default function Layout(props){
    return (
        <Div className="layout">
            <Header/>
            {/* <LinearDeterminate progress={75}/> */}
            <Box
                margin='0 auto'
                sx={{
                    maxWidth: {
                        xs: "100%",
                        sm: "100%",
                        md: "90%",
                        lg: "80%"
                    }, 
                }}
            >
            <Outlet/>
            </Box>
        </Div>
    )
}

const Div = styled.div`
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    background: #121212;
`